<template>
    <div :class="{ selected }" class="plan">
        <div class="header">Instagram Plus</div>
        <div class="plan-price-section">
            <div class="plan-price-details">
                <span :class="{ tl: $_.get(site, 'instagramPlusBasePrice.currency', 'tl') === 'tl' }" class="amount">{{
                    $_.get(site, "instagramPlusBasePrice.value", DEFAULT_PRICING.PLUS.tl.price)
                }}</span>
                <i
                    ><i class="slash">/</i>
                    <i class="billed-month"
                        >{{ $t("billing.month") }}
                        <i class="billed-yearly hide"><br />{{ $t("billing.billedMonthToMonth") }}</i></i
                    ></i
                >
            </div>
        </div>
        <md-button
            :disabled="selected"
            class="md-raised md-primary w-100"
            style="transform: scale(0.7); font-size: x-large; border-radius: 10%"
            @click="onSelected"
            >{{ $t(selected ? "wp.subscribed" : "wp.subscribe") }}
        </md-button>
        <span class="text-succes">-</span>
        <a-divider>{{ $t("wp.planDetails") }}</a-divider>
        <div class="features">
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.includesAllBasicPlans") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span class="text-success">{{ $t("wp.chatbotIntegration") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span class="text-success">Auto Accept DM Requests</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>Chatbot - Buttons Message Support</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>Chatbot - Gallery Message Support</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>Chatbot - Quick Reply Button Message Support</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.locationMessageSupport") }} (Coming Soon)</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CONFIG from "../../../../../../config/config";

export default {
    name: "InstagramPlusPlanCard",
    props: {
        onSelected: {
            type: Function,
            default: () => {},
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            siteId: (state) => state.site.site._id,
            site: (state) => state.site.site,
        }),
    },
    data() {
        return {
            DEFAULT_PRICING: CONFIG.PRICING.INSTAGRAM,
        };
    },
};
</script>

<style scoped></style>
